(function(angular) {
  'use strict';

  var app = angular.module('asDemandMgr');

  app.service('advertiserApi', [
    '$http',
    '$q',
    function($http, $q) {
      this.getList = function(sort, search, page) {
        var url = '/demandmgr/advertiser/list' + getReportUrl(sort, search, {}, page);

        return $q(function(resolve, reject) {
          $http.get(url).then(
            // success
            function(res) {
              resolve(res.data);
            },
            // error
            function(res) {
              reject({ code: res.data.errorCode, message: res.data.message });
            }
          );
        });
      };

      this.delete = function(advertiserId) {
        var url = '/demandmgr/advertiser?id=' + advertiserId;

        return $q(function(resolve, reject) {
          $http.delete(url).then(
            // success
            function(res) {
              resolve();
            },
            // error
            function(res) {
              reject();
            }
          );
        });
      };

      this.save = function(advertiser) {
        var url = '/demandmgr/advertiser/save';

        return $q(function(resolve, reject) {
          $http.post(url, advertiser).then(
            // success
            function(res) {
              if (res.data.status === 'success') {
                resolve();
              } else {
                reject(res.data);
              }
            },
            // error
            function(res) {
              reject();
            }
          );
        });
      };

      this.read = function(ioId) {
        var url = '/demandmgr/advertiser/read?id=' + ioId;

        return $q(function(resolve, reject) {
          $http.get(url).then(
            // success
            function(res) {
              resolve(res.data);
            },
            // error
            function(res) {
              reject();
            }
          );
        });
      };

      this.isAdvertiserNameUnique = function(
        advertiserName,
        advertiserId
      ) {
        var url =
          '/demandmgr/advertiser/check-name?' +
          '&advertiserId=' + advertiserId +
          '&name=' + advertiserName;

        return $q(function(resolve, reject) {
          $http.get(url).then(
            // success
            function(res) {
              resolve(res.data);
            },
            // error
            function(res) {
              reject();
            }
          );
        });
      };
    },
  ]);
})(window.angular);
